/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAddCreditCardAuthorizationIdResponse
 */
export interface GetAddCreditCardAuthorizationIdResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAddCreditCardAuthorizationIdResponse
     */
    addCreditCardAuthorizationId: string;
}

/**
 * Check if a given object implements the GetAddCreditCardAuthorizationIdResponse interface.
 */
export function instanceOfGetAddCreditCardAuthorizationIdResponse(value: object): value is GetAddCreditCardAuthorizationIdResponse {
    if (!('addCreditCardAuthorizationId' in value) || value['addCreditCardAuthorizationId'] === undefined) return false;
    return true;
}

export function GetAddCreditCardAuthorizationIdResponseFromJSON(json: any): GetAddCreditCardAuthorizationIdResponse {
    return GetAddCreditCardAuthorizationIdResponseFromJSONTyped(json, false);
}

export function GetAddCreditCardAuthorizationIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAddCreditCardAuthorizationIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'addCreditCardAuthorizationId': json['addCreditCardAuthorizationId'],
    };
}

  export function GetAddCreditCardAuthorizationIdResponseToJSON(json: any): GetAddCreditCardAuthorizationIdResponse {
      return GetAddCreditCardAuthorizationIdResponseToJSONTyped(json, false);
  }

  export function GetAddCreditCardAuthorizationIdResponseToJSONTyped(value?: GetAddCreditCardAuthorizationIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addCreditCardAuthorizationId': value['addCreditCardAuthorizationId'],
    };
}

